import { createContext } from "react";
import { getDefaultDatacenter } from "./utils";

export interface AtsIntegration {
  client_id: string;
  client_secret: string;
  environment: "LIVE" | "UAT";
  datacenter_id: "dc2" | "dc3" | "dc4" | "dc5";
  default_group_id: string;
  report_url_type: string;
}

export interface PageUpIntegrationContextType {
  atsIntegrationData: AtsIntegration;
  setAtsIntegration: (atsIntegrationData: AtsIntegration) => void;
}

export const PageUpIntegrationContext =
  createContext<PageUpIntegrationContextType>({
    atsIntegrationData: {
      client_id: "",
      client_secret: "",
      environment: "UAT",
      datacenter_id: getDefaultDatacenter(),
      default_group_id: "",
      report_url_type: "DIRECT_PDF_URL",
    },
    setAtsIntegration: (newState: AtsIntegration) => newState,
  });
